<template>
  <v-container fluid>
  <v-layout data-app wrap>

    <!-- TOP NAV BAR -->
    <v-flex xs12>
      <NavBarHome></NavBarHome>
    </v-flex>
    <v-flex xs12>
      <br/>
      <v-banner v-if="impersonation" class="impersonation-banner yellow lighten-2">
      <v-avatar slot="icon" color="deep-orange accent-4" size="40">
        <v-icon color="white">
          people_alt
        </v-icon>
      </v-avatar>
      You are viewing the survey of <strong>{{officeDescription}}</strong>.
      <template v-slot:actions>
        <v-btn color="deep-orange accent-4 white--text" @click="exit()">Exit</v-btn>
      </template>
    	</v-banner>
  	</v-flex>

    <!-- LEFT CONTENTS -->
    <v-flex xs6 mt-5>
      <div class="content-left-top">
        <h1>Welcome!  <h3><span style="color:red">{{participateMessage}}</span></h3></h1>
        <p><span class="col-orange">{{FYVolumeLanding}}</span></p>
				<p>Thank you for participating in the Volume 74 (FYs 2024 - 25)<span><i> Survey of Federal Funds for Research and Development!</i></span></p>
        <p>{{ welcomeMessage }}</p>
        <p>The survey is authorized by the National Science Foundation Act of 1950 (42 U.S. Code 1862, P.L. 87-835), as amended, and the America COMPETES Reauthorization Act of 2010 §505.</p>
        <p><span class="col-orange">
					<ul>
						<li>Please track the approximate person hours utilized to complete the online Survey of Federal Funds Survey for R&D. You will be asked to estimate the hours used to complete the survey before submittal.</li>
						<li>Submit due date : August 6<sup>th</sup> 2025</li>
					</ul>
					</span>
				</p>
				<p><span class="col-orange">
					<b>Warning:</b> Currently, there is an issue with the e-mail system that is affecting submission e-mails. If the system stays at the submission page and you are not sure if the survey was submitted, please return to the landing page. If there is a statement that the survey has been submitted, you are done. We will alert offices that have submitted when the problem is solved. At that time, if you want to get a submission e-mail, we will unlock your survey, so you can resubmit. We apologize for the inconvenience and thank you for your cooperation.
				</span></p>
      </div>
      <div class="content-left-bottom">
        <div class="sign-in-box">
          <h2>{{currentUserInfo}}</h2>
          <h2>{{messageInfo}}</h2>
         <h2>
          <div>
            <v-form ref="form" lazy-validation>
              <b-container fluid>
                <b-row class="mb-1">
                  <b-col cols="3">Volume <span style="color:red">*</span></b-col>
                  <b-col>
                    <select v-model="volume" class="form-control" required :rules="volumeRule" style="width:50%" @change="onChangeVolume($event)">
                        <option value="null">Select</option>
                        <option value="73"> 73 </option>
												<option value="74" selected> 74 (Current) </option>
                    </select>
                    <span style="color:orange;font-size:18px;font-weight: normal;">{{dropdownmessage}}</span>
                  </b-col>
                </b-row>
              </b-container>
            </v-form>
          </div>
         </h2>
          <button
            type="submit"
            name="btnlogin"
            class="btn btn-default "
            @click="start()"
            :class="buttonDisplay"
          >Open Volume <b style="color:white">{{volume}}</b> Survey</button>
					<p v-if="isLocked && lockMessage"><br><b style="text-align:center;color:red">{{lockMessage}}</b></p>
          <p><br><b style="text-align:right;color:red">The system works best if you open questions in sequential order. After that, answer in any order.</b></p>
        </div>
      </div>
    </v-flex>

    <!-- RIGHT CONTENTS -->
    <v-flex xs6 mt-5>
      <div class="content-right">
        <div class="content-box">
          <h3 class="tools" style="font-size: 20px;">Survey Tools</h3>
          <ul class="list-lvl1" style="font-size: 18px;">
            <li>
              <a href="#" @click="change" :class="isNotUnderAdmin || manageAggregation || downloadDisable">Change Password</a>
            </li>
						<li>
                <a v-if="isStandardSurvey()" href="#" @click="Survey4SpreadSheet(true);" :class="downloadDisable || manageAggregation">Download Blank Spreadsheet (XLS)</a>
                <a v-else href="#" @click="Survey4SpreadSheet(true);" :class="downloadDisable || manageAggregation">Download Blank Spreadsheet (XLS)</a>
                &nbsp;<span style="color:blue;">{{downloadMessageEmpty}}</span>
            </li>
						<li>
                 <a v-if="isStandardSurvey()" @click="Survey4SpreadSheet(false);" :class="downloadDisable" href="#">Download Volume {{volume}} Data</a>
                  <a @click="Survey4SpreadSheet(false);" v-else  :class="downloadDisable" href="#">Download Volume {{volume}} Data (XLS)</a>
                   &nbsp;<span style="color:blue;">{{downloadMessage}}</span>
            </li>
						<li>
              <a href="#" @click="manageReportingUnits" :class="downloadDisable || manageAggregation || isNotUnderSurvey">Manage Reporting Units (add new suboffices, aggregate suboffice data, and monitor suboffice progress)</a>
            </li>
            <li>
              <a href="#" @click="officeContact" :class="downloadDisable || manageAggregation">Update Office Contact Information</a>
            </li>
          </ul>
        </div>
        <div class="content-box">
          <h3 class="materials" style="font-size: 20px;">Reference Materials</h3>
					<ul class="list-lvl1" style="font-size: 18px;">
            <li>
              <a href="./Attachments/Frequently_Asked_Questions.pdf" target="_blank" :class="isNotUnderSurvey || manageAggregation">Frequently Asked Questions (PDF)</a>
            </li>
						<li>
              <a href="./Attachments/Glossary.pdf" target="_blank" :class="isNotUnderSurvey || manageAggregation">Glossary (PDF)</a>
            </li>
						<li>
              <a v-if="isStandardSurvey()" href="./Attachments/How_the_Survey_Is_Organized_Standard.pdf" download :class="isNotUnderSurvey || manageAggregation">How the Survey Is Organized (PDF)</a>
              <a v-else href="./Attachments/How_the_Survey_Is_Organized_DOD.pdf" download :class="isNotUnderSurvey || manageAggregation">How the Survey Is Organized (PDF)</a>
            </li>
            <li>
              <a v-if="isStandardSurvey()" href="./Attachments/Organization_Codes_for_Higher_Education_and_Nonprofit_Institutions.xlsx" download :class="isNotUnderSurvey || manageAggregation">Organization Codes for Higher Education and Nonprofit Institutions (XLS)</a>
              <a v-else href="./Attachments/Organization_Codes_for_Higher_Education_and_Nonprofit_Institutions.xlsx" download :class="isNotUnderSurvey || manageAggregation">Organization Codes for Higher Education and Nonprofit Institutions (XLS)</a>
            </li>
            <li>
              <a href="./Attachments/List_RD_field_example_disciplines.pdf" target="_blank" :class="isNotUnderSurvey || manageAggregation">R&D Fields and Example Disciplines (PDF)</a>
            </li>
						<li>
              <a href="./Attachments/Web_Instructions.pdf" target="_blank" :class="isNotUnderSurvey || manageAggregation">Web Survey Instructions (PDF)</a>
            </li>
						<li>
              <a href="./Attachments/Examples_RD_types.pdf" target="_blank" :class="isNotUnderSurvey || manageAggregation">Examples of RD types (PDF)</a>
            </li>
						<li>
              <a href="https://players.brightcove.net/679256133001/NkgrDczuol_default/index.html?videoId=6372803992112" target="_blank" :class="isNotUnderSurvey || manageAggregation">Vol.74 Fed Funds Webinar</a>
            </li>
          </ul>
        </div>
      </div>
    </v-flex>
  </v-layout>
  <br/>
  <Footer></Footer>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue';
import { authTokenService } from '@/services/authTokenService.js';
import { authService } from '@/services/authService.js';
import { surveyService } from '@/services/surveyService';
import { utilityService } from '@/services/utilityService';
import { officeManagementService } from "@/services/officeManagementService.js";
import { CONSTANTS } from '../common/constants';
import router from '@/router';
import { NavBarHome } from '@/components/NavBarHome.vue';
import { footer } from '@/components/Footer.vue';
import fileDownload from 'js-file-download';
export default {
  name: 'Landing',
  components: {},
  data: () => ({
    volumeRule: [v => !!v || 'Volume is required'],
    select: null,
    surveys: [],
    display: true,
		surveyType: Number,
		isLocked: false,
		lockMessage: null,
    isNotUnderSurvey: null,
    isSurveyLocked: null,
    participateMessage: null,
    isDownloading: false,
    downloadMessage: null,
    downloadMessageEmpty: null,
    impersonation: false,
    officeDescription: '',
    officeId: '',
    isNotUnderAdmin: null,
    volume: null,
    dropdownmessage: null,
    downloadDisable: null,
    FYVolume: null,
    messageInfo: null,
    cVolume: null,
    manageAggregation: null,
    currentUserInfo: null,
    downloadMsg: null,
    FYVolumeLanding: null,
		buttonDisplay: null,
		welcomeMessage: null
	}),
  mounted () {
    debugger;
    const me = this;
    me.FYVolume = null;
    me.FYVolumeLanding = null;
    me.downloadDisable = "isDisabled";
		me.buttonDisplay = "btnDisplay";
    const claims = authTokenService.getClaims();
    me.currentUserInfo = "Current User: " + claims.userName;
    if (claims.userName === "Admin") {
      authTokenService.setNotaAdmin(false);
    } else {
      //this case id return to check in case of not an admin
      authTokenService.setNotaAdmin(true);
    }
    if (claims.userName === "Admin") {
        const activeId = authTokenService.getActiveSurveyId();
        claims.surveyId = activeId;
        me.impersonation = true;
        me.isNotUnderAdmin = "isDisabled";
        officeManagementService.getOfficeBySurveyId(activeId).then(function (response) {
            if (response && response.data) {
              me.officeDescription = response.data.description;
              me.officeId = response.data.id;
            }
				});
			} else {
      //this case id return to check in case of not an admin
      authTokenService.setNotaAdmin(true);
    }
    if (claims.surveyId == undefined) {
       me.isNotUnderSurvey = "isDisabled";
       me.participateMessage = "Please check with the administrator to participate in the survey";
    }

    const currentVolume = authTokenService.getCurrentVolume();
    me.volume = currentVolume;
    me.changeVolume(me.volume);
    me.setIsLocked();
  },
  methods: {
    getDoc () {
      return '@/assets';
    },
    logout () {
      authService.logout();
    },
    start () {
      debugger;
      const me = this;
			const activeId = authTokenService.getActiveSurveyId();
  		surveyService.setCurrentUser(me.activeId, true).then(function (response) {
				if (response && response.data != null) {
					console.log("Current user has been set");
          me.$store.dispatch('validation/loadQuestionStatuses');
		      me.$store.dispatch('validation/loadSurveyValidationMessages');
		      me.$store.dispatch('loadAllAnswers', { surveyId: me.activeId, qId: 0 });
          router.push({ name: 'home' });
				}
			})
			.catch(function (e) {
				console.log(e);
				console.log('Couldn\'t set current user');
				throw e;
			});
    },
    admin () {
      router.push({ name: 'admin' });
		},
		change () {
      router.push({ name: 'changepassword' });
		},
		officeContact () {
			router.push({ name: 'officecontact' });
    },
    manageReportingUnits () {
      router.push({ name: 'reportingunits' });
    },
		progressMonitor () {
      router.push({ name: 'progressmonitor' });
    },
    enlistOthers () {
      router.push({ name: 'enlistothers' });
    },
    unavailable () {
      router.push({ name: 'unavailable' });
    },
    isStandardSurvey: function () {
      if (this.surveyType === utilityService.getSurveyTypes().Standard)
      {
          return true;
      }
      else if (this.surveyType === utilityService.getSurveyTypes().DOD)
      {
         return false;
      }
		},
    Survey4SpreadSheet: function (flag) {
      debugger;
      const me = this;
      me.isDownloading = true;
      if (!flag) {
        me.isNotUnderSurvey = "isDisabled";
        me.downloadMessage = "Downloading please wait..this may take a minute or 2..";
      }
      else {
        me.isNotUnderSurvey = "isDisabled";
        me.downloadMessageEmpty = "Downloading please wait..this may take a minute or 2..";
      }
      const claims = authTokenService.getClaims();
      const activeId = authTokenService.getActiveSurveyId();
      claims.surveyId = activeId;
      if (me.surveyType === utilityService.getSurveyTypes().Standard) {
          surveyService.getExcelDownload(claims.surveyId, flag).then(function (response) {
          if (response && response.data != null) {
              var fileURL = window.URL.createObjectURL(new Blob([response.data],
              { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
              console.log(response.data);
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              if (!flag)
                fileLink.setAttribute('download', 'Excel_FFS_standard__Version' + me.volume + '_' + claims.userName + '.xlsx');
              else
                fileLink.setAttribute('download', 'Excel_FFS_standard__Version' + me.volume + '_Blank.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();
              window.URL.revokeObjectURL(fileURL);
              fileLink.remove();
              me.isDownloading = false;
              me.downloadMessage = null;
              me.downloadMessageEmpty = null;
              me.isNotUnderSurvey = "";
            }
            else {
                me.isDownloading = false;
                me.downloadMessage = null;
                me.downloadMessageEmpty = null;
                me.isNotUnderSurvey = "";
            }
        });
      }
      else if (me.surveyType === utilityService.getSurveyTypes().DOD) {
         surveyService.getExcelDownload(claims.surveyId, flag).then(function (response) {
          if (response && response.data != null) {
              var fileURL = window.URL.createObjectURL(new Blob([response.data],
              { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
              console.log(response.data);
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              if(!flag)
                fileLink.setAttribute('download', 'Excel_FFS_DOD_Version' + me.volume + '_' + claims.userName +'.xlsx');
              else
                fileLink.setAttribute('download', 'Excel_FFS_DOD__Version' + me.volume + '_Blank.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();
              window.URL.revokeObjectURL(fileURL);
              fileLink.remove();
              me.isDownloading = false;
              me.downloadMessage = null;
              me.downloadMessageEmpty = null;
              me.isNotUnderSurvey = "";
            }
            else {
                me.isDownloading = false;
                me.downloadMessage = null;
                me.downloadMessageEmpty = null;
                me.isNotUnderSurvey = "";
            }
        });
      }
		},
		setIsLocked: function () {
			const me = this;
      me.activeId = authTokenService.getActiveSurveyId();
      if (me.activeId != null) {
        surveyService.getLockStatus(me.activeId).then(function (response) {
          if (response && response.data != null) {
            if (response.data.isLocked === true) {
                me.isLocked = true;
                me.isSurveyLocked = "isDisabled";
                me.lockMessage = "This survey has been submitted and locked."
            } else if (response.data.currentUser != null) {
              me.isLocked = true;
              me.lockMessage = `The survey is in use by user: ${response.data.currentUser}`;
            }
            else {
              me.isSurveyLocked = "";
              me.lockMessage = null;
            }
          }
        })
        .catch(function (e) {
          console.log(e);
          console.log('Error loading survey lock status')
          throw e;
        });
      }
     return me.isLocked;
		},
    exit () {
      router.push({ name: 'admin.stats' });
    },
    onChangeVolume (event) {
      debugger;
      const me = this;
      if (event.target.options[event.target.options.selectedIndex].value === "null") {
          me.volume = null;
          me.dropdownmessage = "Please select.";
          me.lockMessage = null;
          me.downloadDisable = "isDisabled";
          me.FYVolume = null;
          me.messageInfo = null;
          me.FYVolumeLanding = null;
					me.buttonDisplay = "btnDisplay";
      }
      else {
          me.dropdownmessage = "Processing please wait..";
          me.volume = event.target.options[event.target.options.selectedIndex].value;
          me.changeVolume(me.volume);
      }
    },
    changeVolume (volume) {
      const me = this;
      const claims = authTokenService.getClaims();
      if (volume != null) {
				if (claims.userName === "Admin") {
					me.inCaseofAdmin(volume);
				}
				else {
        	surveyService.getSurveyId(volume, claims.userName).then(function (response) {
            me.currentUserInfo = "Current User: " + claims.userName;
            if (response.data === 0) {
                  me.dropdownmessage = "Processing please wait..";
                  me.messageInfo = "No data available for volume: " + volume;
                  me.cVolume = null;
                  me.lockMessage = null;
                  me.downloadDisable = "isDisabled";
                  me.FYVolume = null;
                  me.FYVolumeLanding = null;
                  me.dropdownmessage = null;
									me.manageAggregation = "isDisabled";
									me.buttonDisplay = "btnDisplay";
						} else if (response && response.data) {
                authTokenService.setActiveSurveyId(response.data);
                /*This below code to display on tghe banner*/
                switch (me.volume) {
									case "73":
                      //me.FYVolumeLanding = "New design features for Volume 73 (2023-24)";
                      me.FYVolume = "FYs 2023 - 24 (Volume 73)";
                      me.messageInfo = "";
                      me.cVolume = "73";
                      me.manageAggregation = "isDisabled";
											me.buttonDisplay = "btnDisplay";
                      break;
									case "74":
                      me.FYVolume = "FYs 2024 - 25 (Volume 74)";
                      me.messageInfo = "";
                      me.cVolume = "74";
                      me.isNotUnderSurvey = "";
                      me.manageAggregation = "";
											me.buttonDisplay = "";
                      break;
                  default:
                      me.FYVolume = null;
                      me.messageInfo = "No data available for volume: " + volume;
                      me.cVolume = null;
                      me.volume = null;
											me.buttonDisplay = "btnDisplay";
                      break;
                }
                authTokenService.setFYVolume(me.FYVolume);
                authTokenService.setCurrentVolume(me.cVolume);
                me.activeId = authTokenService.getActiveSurveyId();
                /*this case id return to check in case of not an admin*/
                authTokenService.setNotaAdmin(true);
                surveyService.getSurveyType(me.activeId).then(function (response) {
                  if (response && response.data) {
                    me.surveyType = response.data;
                    me.isLocked = me.setIsLocked();
                    me.dropdownmessage = "";
                    me.downloadDisable = "";
                    me.isNotUnderSurvey = "";
                    me.display = false;
										if (me.surveyType === utilityService.getSurveyTypes().Standard) {
											me.welcomeMessage = "There is one new question at the end of the survey. It requests the amounts of R&D conduct and R&D plant obligations from each of these supplemental appropriations: the CHIPS and Science Act, the Inflation Reduction Act, and the Infrastructure Investment and Jobs Act. These amounts should be included in what you report in the other questions.";
										} else if (me.surveyType === utilityService.getSurveyTypes().DOD) {
											me.welcomeMessage = "";
										}
                  }
                });
              }
          })
          .catch(function (e) {
            me.dropdownmessage = "";
            me.downloadDisable = "isDisabled";
            me.isNotUnderSurvey = "";
            me.display = false;
            console.log(e);
            console.log('Error: survey Id on Loading Page ');
            throw e;
          });
       }
			}
    },
		inCaseofAdmin (volume) {
			 const me = this;
				switch (volume)	{
					case "73":
							me.FYVolumeLanding = " 73 (2023-24)";
							me.FYVolume = "FYs 2023-24 (Volume 73)";
							me.messageInfo = "";
							me.cVolume = "73";
							me.manageAggregation = "isDisabled";
							me.buttonDisplay = "btnDisplay";
							break;
					case "74":
							me.FYVolumeLanding = " 74 (2024-25)";
							me.FYVolume = "FYs 2024-25 (Volume 74)";
							me.messageInfo = "";
							me.cVolume = "74";
							me.isNotUnderSurvey = "";
							me.manageAggregation = "";
							me.buttonDisplay = "";
							break;
					default:
							me.FYVolume = null;
							me.messageInfo = "No data available for volume: " + volume;
							me.cVolume = null;
							me.volume = null;
							me.buttonDisplay = "btnDisplay";
							break;
				}
				authTokenService.setFYVolume(me.FYVolume);
				authTokenService.setCurrentVolume(me.cVolume);
				me.activeId = authTokenService.getActiveSurveyId();
				/*this case id return to check in case of not an admin*/
				authTokenService.setNotaAdmin(false);
				surveyService.getSurveyType(me.activeId).then(function (response)	{
					if (response && response.data) {
						me.surveyType = response.data;
						me.isLocked = me.setIsLocked();
						me.dropdownmessage = "";
						me.downloadDisable = "";
						me.isNotUnderSurvey = "";
						me.display = false;
					}
				});
			}
  }
};
</script>

<style scoped>
.btnDisplay {
  display: none;
}
.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
	pointer-events: none;
}
h1 {
  margin: 20px 0 !important;
  padding: 0 !important;
  border: none !important;
  font-size: 20pt;
  font-style: italic;
  font-weight: bold;
}
h3 {
  /* font-family: Calibri(body), Georgia, Times, Times New Roman, Serif !important; */
  font-size: 14pt;
  font-weight: normal;
  color: #B4500E;
}
a {
  font-weight: bold;
  color: #0751a0;   /* 508 AAA > 7 */
}
.content-left-top {
  padding: 0% 10% 5% 20%;
  text-align: left;
  /* font-family: Calibri(body), Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; */
}
.col-orange {
  color: #c1560e;
  font-weight: bold;
}
.content-left-bottom {
  padding: 0% 0% 0% 25%;
  text-align: center;
  /* font-family: Calibri(body), Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; */
}
.sign-in-box {
  width: 80%;
}
.btn {
  width:400px;
  margin: 0%;
  padding: 0%;
  color: white;
  font-weight: bold;
  font-size: 12pt;
  background-color: #3b9ee8 !important;
  width: fit-content;
  padding: 3% 5% 3% 5%;
  border-width: 1px;
  border-color:#ebf0f9 !important;
}
.btn:hover {
  color: #ffffff;
  border-color:#3b9ee8 !important;
}
.content-right {
  padding: 2% 10% 0% 5%;
  text-align: left;
  /* font-family: Calibri(body), Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; */
}
.content-box {
  /* background-color: #ececec; */
  background-color: #f3f3f3;
  border: 1px solid #e0dede;
  padding: 2% 2% 1% 2%;
  margin-bottom: 2%;
  font-size: 9pt;
}
.tools {
  background-image: url(../assets/tools.png);
  background-size: 25px;
  background-repeat: no-repeat;
  margin: 5px 0 19px 0;
  padding: 2px 0 0 44px;
}
.data {
  background-image: url(../assets/data.png);
  background-size: 25px;
  background-repeat: no-repeat;
  margin: 5px 0 19px 0;
  padding: 2px 0 0 44px;
}
.materials {
  background-image: url(../assets/materials.png);
  background-size: 25px;
  background-repeat: no-repeat;
  margin: 5px 0 19px 0;
  padding: 2px 0 0 44px;
}
.list-lvl1 {
  margin-top: -2%;
  margin-left: 30px;
}
.list-lvl2 {
  margin-left: 25px;
}
.list-item {
  margin-bottom: 0px;
}
.top-gray {
  background-color: #e3e3e3;
  padding: 11px 0;
}
.main-title {
  color: #313b52;
  /* font-family: Georgia, Times New Roman, Times, serif; */
  font-size: 25px;
}
.sign-in-title-outer {
  padding-top: 60px;
}
.top-title-left-border {
  border-left: 1px solid #969696;
}
.sign-in-sub-title {
  /* font-family: Georgia, Time New Roman, Times, Serif; */
  color: #313b52;
  font-size: 21px;
  line-height: 40px;
  font-weight: bold;
  margin: 0 0 11px 0;
}
.sign-in-sub-title-right {
  /* font-family: Georgia, Time New Roman, Times, Serif; */
  color: #313b52;
  font-size: 40px;
  line-height: 59px;
  margin: 0 0 11px 0;
}
.blue-bar {
  background-color: #01bced;
  padding: 6px 0;
}
.blue-title-text {
  /* font-family: Georgia, Times, Times New Roman, san-serif; */
  color: #000000;
  font-size: 28px;
  font-weight: normal;
}
.blue-title-text a {
  color: #1b405a;
}
.blue-bar-title {
  text-align: center;
}
.content-space {
  padding: 49px 23px;
  /* font-family: Arial, Helvetica, san-serif; */
  font-size: 1em;
  line-height: 1.8125em;
  color: #5b5853;
}
.sub-titles-bold {
  font-size: 20px;
  font-weight: bold;
  display: block;
  margin-bottom: 11px;
}
.password-reset-space {
  padding-top: 23px;
  padding-left: 44px;
}
.password-reset-space a {
  color: #195d8d !important;
  font-size: 16px;
}
.about-title {
  /* font-family: Georgia, Times, Times New Roman, Serif; */
  color: #5b5853;
  font-size: 27px;
  line-height: 34px;
  font-weight: normal;
  background-image: url(../assets/icn-about.png);
  background-repeat: no-repeat;
  margin: 5px 0 19px 0;
  padding: 2px 0 0 44px;
}
/* STYLES FOR NSF DEFAULT */
.header,
.feature {
  width: 1400px;
  margin: 0 auto;
}
.bottom {
  width: 1080px;
  margin: 32px auto;
}

/*CSS For Developer*/
html,
body {
  margin: 0;
  padding: 0;
  background-color: #ffffff !important;
}
.category-title-revised {
  /* font-family: Georgia, Times, Times New Roman, Serif !important; */
  color: #5b5853 !important;
  text-transform: none !important;
  font-size: 18px !important;
  font-weight: normal !important;
  padding-left: 9px !important;
  margin: 22px 0 9px 0 !important;
}
.q-revised {
  background-color: #d2d2d2 !important;
  padding: 5px 0 !important;
  border-radius: 4px !important;
}
.question-title {
  color: #000000 !important;
  font-size: 15px !important;
}
.Q .title:hover {
  background-color: #d2d2d2 !important;
}
#overall-status {
  border-top: #01bced 4px solid !important;
  padding: 15px !important;
  width: 97% !important;
}
#overall-status {
  border-left: #c4c4c4 1px solid !important;
}
#overall-status {
  border-right: #c4c4c4 1px solid !important;
}
#overall-status {
  border-bottom: #c4c4c4 1px solid !important;
}
#overall-status table th {
  border-left-color: #e98412 !important;
}
.not-ready {
  margin-top: 11px !important;
}
.status-content {
  width: 1080px;
  margin: 0 auto;
  padding-top: 0px;
  text-align: center;
}

/*CSS For Developer*/
.error {
  color: red;
  padding-bottom: 1em;
}
table tr td.lbl {
  padding: 0.7em 1em 0.7em 0;
}
table tr td.form_buttons {
  padding-top: 1em;
}
label {
  margin-bottom: 0 !important;
}
</style>
